module.exports = __webpack_public_path__ + "static/img/jzjl.4a2b9d96.png";